import Service from '@ember/service';
import { inject as service } from '@ember/service';
//import type SiteService from '@ebiz/ember-aditools-site/services/aditools-site';
import CdpService from '../services/cdp';
import ModelService from 'photodiode/services/model';
import { SensorData } from '../models/sensor';

export default class SensorService extends Service {
  @service('aditools-site') declare siteconfig: { [key: string]: string }; // SiteService;
  @service('model') declare modelService: ModelService;
  @service('sensor') declare sensorService: SensorService;
  @service declare cdp: CdpService;
  sensors?: Promise<SensorData[] | null>;
  limits?: Limits;
  shoppingCartUrl?: string;

  load(config: Promise<PhotodiodeConfigJson | null>): void {
    if (config) {
      this.sensors = config.then((cfg) => {
        if (cfg === null) return cfg;
        this.limits = cfg.limits;
        this.shoppingCartUrl = this.siteconfig['ShoppingCartBaseUrl'];
        return this.buildSensorData(
          cfg.sensors,
          this.siteconfig['SiteUrl'] + '/media/' + this.siteconfig['AdiLocale'] + '/designtools/photodiode/models/',
        );
      });
    }
  }

  async buildSensorData(data: Sensor[], modelsURL: string): Promise<SensorData[]> {
    let sensorData = [];
    for (const sensorItem of data) {
      //These values will be overridded by values from the CDP. Only for reference.
      let sensor = {
        id: 'PDB-C134',
        partNumber: 'PDB-C134',
        cost: '$1.71',
        manufacturer: 'Advanced Photonix',
        packageType: 'Radial',
        packageSize: 'null',
        spectralRange: '700n ~ 1100n',
        spectralPeak: '9.00E-07',
        sensitivity: '0.54',
        darkCurrent: '2.00E-09',
        resistance: '2.00E+09',
        capacitance: '6.E-12',
        responseTime: '1.00E-08',
        reverseBreakdown: '50',
        area: '1.54',
        angle: '30',
        operatingTemp: '-40 ~ 80',
        spiceFileUrl: 'spice/Sensors/PDB-C134.cir.txt',
        vendorLink: 'http://www.advancedphotonix.com',
        vendorDatasheetUrl: 'http://www.advancedphotonix.com/ap_products/pdfs/PDB-C134.pdf',
      };
      let minSpecRange = '',
        maxSpecRange = '',
        minTemp = '',
        maxTemp = '';
      for (const parameter of sensorItem.parameters) {
        const paramValue = parameter.value[0] ? parameter.value[0].basevalue : null;
        const displayValue = parameter.value[0] ? parameter.value[0].displayvalue : null;
        switch (parseInt(parameter.id)) {
          case 4499:
            sensor.cost = paramValue as string;
            break;
          case 4494:
            sensor.packageType = paramValue as string;
            break;
          case 4485:
            minSpecRange = (displayValue as string | number) + 'n';
            break;
          case 4486:
            maxSpecRange = (displayValue as string | number) + 'n';
            break;
          case 4484:
            sensor.spectralPeak = paramValue as string;
            break;
          case 4487:
            sensor.sensitivity = paramValue as string;
            break;
          case 4488:
            sensor.darkCurrent = paramValue as string;
            break;
          case 4489:
            sensor.resistance = paramValue as string;
            break;
          case 4490:
            sensor.capacitance = paramValue as string;
            break;
          case 4227:
            sensor.responseTime = paramValue as string;
            break;
          case 4491:
            sensor.reverseBreakdown = paramValue as string;
            break;
          case 4492:
            sensor.area = displayValue as string;
            break;
          case 4493:
            sensor.angle = paramValue as string;
            break;
          case 4395:
            minTemp = paramValue as string;
            break;
          case 4396:
            maxTemp = paramValue as string;
            break;
          case 4497:
            sensor.vendorLink = paramValue as string;
            break;
          case 4498:
            sensor.vendorDatasheetUrl = paramValue as string;
            break;
        }
      }
      sensor.id = sensorItem.id;
      sensor.partNumber = sensorItem.display;

      //We have some photoDiodes that do not have matching part numbers to ids, therefore the photodiode selected does not select since those properties do not match TRK 05-01-2013
      if (sensor.id != sensor.partNumber) {
        sensor.partNumber = sensor.id;
      }
      sensor.manufacturer = sensorItem.mfr;
      sensor.spectralRange = minSpecRange.toString() + ' ~ ' + maxSpecRange.toString();
      sensor.operatingTemp = minTemp.toString() + ' ~ ' + maxTemp.toString();
      sensor.spiceFileUrl = modelsURL + sensorItem.id + '.cir';

      sensorData.push(sensor);
    }
    return sensorData;
  }
}

declare module '@ember/service' {
  interface Registry {
    sensor: SensorService;
  }
}
